import { Link } from 'react-router-dom';

const entries = [
  {
    to: '/category/ethics',
    icon: 'ri-emotion-sad-line',
    title: '伦理剧集',
    desc: '家庭、情感与人性的多重抉择',
    count: '108 部',
    tone: 'bg-primary-50 text-primary-700 border-primary-200',
  },
  {
    to: '/category/latest',
    icon: 'ri-time-line',
    title: '最新上线',
    desc: '近三个月上线的精选剧集',
    count: '62 部',
    tone: 'bg-accent-50 text-accent-800 border-accent-200',
  },
  {
    to: '/category/classic',
    icon: 'ri-award-line',
    title: '经典佳作',
    desc: '口碑经得起时间检验的作品',
    count: '46 部',
    tone: 'bg-secondary-100 text-secondary-900 border-secondary-200',
  },
  {
    to: '/search',
    icon: 'ri-search-eye-line',
    title: '全站搜索',
    desc: '按剧名、演员、导演快速查找',
    count: '检索',
    tone: 'bg-background-100 text-foreground-800 border-background-300',
  },
];

export default function CategoryShortcuts() {
  return (
    <section className="w-full px-4 md:px-10 py-10 md:py-14 bg-background-50">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex items-start gap-3.5 p-4 md:p-5 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 hover:bg-background-100/60 transition-all duration-300"
          >
            <span className={`w-11 h-11 md:w-12 md:h-12 rounded-lg border flex items-center justify-center shrink-0 ${entry.tone}`}>
              <i className={`${entry.icon} text-xl`}></i>
            </span>
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-[15px] md:text-base font-semibold text-foreground-950">
                  {entry.title}
                </h3>
                <span className="text-[11px] text-foreground-400">{entry.count}</span>
              </div>
              <p className="text-xs md:text-[13px] leading-6 text-foreground-600 mt-1">{entry.desc}</p>
            </div>
            <i className="ri-arrow-right-up-line ml-auto text-foreground-300 group-hover:text-primary-600 transition-colors"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}